import { HeatNavigationV3 } from "@/controls/heatNavigation-v3";
import { searchHeatNames } from "@/pages/meltshop/repositories/HeatRepository";
import {
	Checkbox,
	Divider,
	FormControlLabel,
	Grid,
	Paper,
	Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LazyBackDropLoading } from "../../../../controls/LazyLoading";
import { Heat } from "../../chemistry-heat-report/models/Heat";
import { useMechanicalByHeatContext } from "./MechanicalByHeatContext";
import { TableMechanical } from "./components/TableMechanical";
import { useHeatNavigation } from "./hooks/useHeatNavigation";
import { useMechanicalData } from "./hooks/useMechanicalData";

export const MechanicalByHeatPage = () => {
	const { state, actions } = useMechanicalByHeatContext();
	const navigate = useNavigate();
	const { heatName: heatNameParam } = useParams();
	const [heatName, setHeatName] = useState(heatNameParam || null);

	const { handleValidSamples } = useHeatNavigation();
	const { getCatalogData, getSampleData } = useMechanicalData();

	useEffect(() => {
		getCatalogData();
	}, [heatName]);

	useEffect(() => {
		getSampleData();
	}, [heatName, state.showOnlyValid, state.heat]);

	useEffect(() => {
		const fetchHeat = async () => {
			if (!state.heat && heatName) {
				try {
					const resp = await searchHeatNames({
						searchText: heatName,
						IncludeIsExternal: null,
					});
					if (resp.ok) {
						const heatFound = resp.data.tables[0].rows.find(
							(h: Heat) => h.HeatName === heatName,
						);
						if (heatFound) {
							actions.setHeat(heatFound);
						}
					}
				} catch (error) {
					console.error("Error buscando el heat:", error);
				}
			}
		};

		fetchHeat();
	}, [state.heat, heatName]);

	return (
		<Paper
			elevation={1}
			style={{
				width: "100%",
				padding: "15px 20px 10px",
				borderRadius: "0.75rem",
				height: "93vh",
				backgroundColor: "#F2F4F7",
			}}
		>
			<LazyBackDropLoading open={state.isLoadingBackground} />
			<Grid container justifyContent="center" alignItems="center">
				<Grid item container md={12} xs={12}>
					<Grid item md={12} xs={12}>
						<Typography
							variant="h5"
							style={{ fontWeight: 600, userSelect: "none" }}
						>
							Mechanical Test
						</Typography>
					</Grid>

					<Grid container direction="row" alignItems="center" spacing={2}>
						<Grid item xs="auto">
							<HeatNavigationV3
								value={heatName || null}
								onChange={(newHeat) => {
									if (newHeat) {
										actions.setHeat(newHeat);
										setHeatName(String(newHeat.HeatName));
										navigate(`/lab-mechanical-by-heat/${newHeat.HeatName}`);
									}
								}}
							/>
						</Grid>
						<Grid item xs="auto">
							<FormControlLabel
								control={
									<Checkbox
										color="primary"
										checked={state.showOnlyValid}
										onChange={(e) => handleValidSamples(e.target.checked)}
									/>
								}
								label="Show valid samples"
							/>
						</Grid>
					</Grid>

					<Divider style={{ paddingTop: "100px" }} />

					<TableMechanical
						loadingGrid={state.isLoadingGrid}
						heat={state.heat}
						mechanicalTests={state.mechanicalTests ?? []}
						mechanicalSamples={state.mechanicalSamples ?? []}
						gradeLimits={state.grades ?? []}
						resultSources={state.sources ?? []}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
